import { render, staticRenderFns } from "./Cuota.vue?vue&type=template&id=f2d58408&"
import script from "./Cuota.vue?vue&type=script&lang=js&"
export * from "./Cuota.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports